import { ConnectedPosition } from '@angular/cdk/overlay';

import { TooltipPosition } from '../public/tooltip.directive';

const tooltipPosition: Record<TooltipPosition, ConnectedPosition> = {
  left: {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
    panelClass: ['tooltip', 'left'],
  },
  right: {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
    panelClass: ['tooltip', 'right'],
  },
  top: {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    panelClass: ['tooltip', 'top'],
  },
  bottom: {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    panelClass: ['tooltip', 'bottom'],
  },
};

export const tooltipPositions = {
  left: [
    tooltipPosition.left,
    tooltipPosition.right,
    tooltipPosition.top,
    tooltipPosition.bottom,
  ],
  right: [
    tooltipPosition.right,
    tooltipPosition.left,
    tooltipPosition.top,
    tooltipPosition.bottom,
  ],
  top: [
    tooltipPosition.top,
    tooltipPosition.bottom,
    tooltipPosition.right,
    tooltipPosition.left,
  ],
  bottom: [
    tooltipPosition.bottom,
    tooltipPosition.top,
    tooltipPosition.right,
    tooltipPosition.left,
  ],
};
